import { render } from "./ModalFileManage.vue?vue&type=template&id=4d3f8872&ts=true"
import script from "./ModalFileManage.vue?vue&type=script&lang=ts"
export * from "./ModalFileManage.vue?vue&type=script&lang=ts"

import "./ModalFileManage.vue?vue&type=style&index=0&id=4d3f8872&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__